import React, { SVGProps } from 'react';

export const EditSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8.38958 10.3977L6.36035 10.6875L6.65008 8.65606L11.8686 3.43758C11.9829 3.32336 12.1187 3.23279 12.268 3.17103C12.4174 3.10927 12.5775 3.07754 12.7391 3.07764C12.9007 3.07774 13.0607 3.10967 13.21 3.17162C13.3593 3.23357 13.4949 3.32431 13.6092 3.43867C13.7234 3.55303 13.8139 3.68877 13.8757 3.83813C13.9375 3.9875 13.9692 4.14756 13.9691 4.30919C13.969 4.47082 13.9371 4.63084 13.8751 4.78013C13.8132 4.92942 13.7224 5.06504 13.6081 5.17926L8.38958 10.3977Z'
      stroke='currentColor'
      strokeWidth='0.88'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.30961 9.63989H2.66961C2.45213 9.63989 2.24356 9.72629 2.08978 9.88006C1.936 10.0338 1.84961 10.2424 1.84961 10.4599V12.0999C1.84961 12.3174 1.936 12.5259 2.08978 12.6797C2.24356 12.8335 2.45213 12.9199 2.66961 12.9199H13.3296C13.4373 12.9199 13.5439 12.8987 13.6434 12.8575C13.7429 12.8163 13.8333 12.7559 13.9094 12.6797C13.9856 12.6036 14.046 12.5132 14.0872 12.4137C14.1284 12.3142 14.1496 12.2076 14.1496 12.0999V10.4599C14.1496 10.3522 14.1284 10.2456 14.0872 10.1461C14.046 10.0466 13.9856 9.95621 13.9094 9.88006C13.8333 9.80392 13.7429 9.74352 13.6434 9.70231C13.5439 9.6611 13.4373 9.63989 13.3296 9.63989H11.6896'
      stroke='currentColor'
      strokeWidth='0.88'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
